<template>
  <wd-popup
    v-model="localShow"
    position="center"
    :z-index="200"
    @close="handleClose"
    custom-style="background: transparent;border-radius: 12px;"
  >
    <view class="absolute top-16px right-16px" @click="handleClose">
      <image
        class="w-16px h-16px"
        :src="themeStore.theme === 'light' ? CloseB : CloseW"
        mode="scaleToFill"
      />
    </view>
    <view class="common-popup">
      <view class="w-full rounded-12px">
        <view class="reg_title">
          <text class="text-18px text-navigate-textColor">{{ title }}</text>
        </view>
        <view class="common-popup-content">
          <slot></slot>
        </view>
      </view>
    </view>
  </wd-popup>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import { useThemeStore } from '@/store'
import CloseW from '@/static/images/common/close_w.png'
import CloseB from '@/static/images/common/close.png'

const themeStore = useThemeStore()

const props = defineProps<{
  modelValue: boolean
  title?: string
}>()

const emit = defineEmits(['update:modelValue', 'close'])

// 使用一个本地变量来管理 show 的状态
const localShow = ref(props.modelValue)

// 监听 props.modelValue 的变化
watch(
  () => props.modelValue,
  (newVal) => {
    localShow.value = newVal
  },
)

// 处理关闭事件
const handleClose = () => {
  emit('update:modelValue', false)
  emit('close')
}
</script>

<script lang="ts">
export default {
  name: 'CommonPopup',
}
</script>

<style lang="scss" scoped>
.dark {
  .reg_title {
    background: linear-gradient(180deg, #003370, #08264a 40%, #111923);
    border-bottom: 1px solid #1a273e;
  }
  .common-popup-content {
    background: #131922;
  }
}
.light {
  .reg_title {
    background: #fff;
    border-bottom: 1px solid #ffffff;
  }
  .common-popup-content {
    background: #f3f6fa;
  }
}
.common-popup {
  width: 90vw;
  // overflow: hidden;
  border-radius: 12px;
  .reg_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
  }
}
</style>
